// extracted by mini-css-extract-plugin
module.exports = {"floatingPayment":"paymentcontainer_floatingPayment__0OV5S"};